const fileUploadTargets = {
  ATTACHMENT: "attachments",
};

export { fileUploadTargets };
